import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import getXcolumnJson from "./xcolumn/list";
import TopTabArea from "@/pages/comp/book_order/shop/order/acommon/list/area/top_tab";
import SearchArea from "@/pages/comp/book_order/shop/order/acommon/list/area/search";
import SumMoneyArea from "@/pages/comp/book_order/shop/order/acommon/list/area/sum_money";

function ListBookGroupArea() {
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});

  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_mcomp_seq: "",
    s_state: "request",
    s_date_type: "",
    s_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
    s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
    s_product_type:"",
    s_product_name: "",
    s_in_out: "out",
    s_title_like: "",
    s_user_name_like: "",
    s_mcomp_name_like: "",
    s_mcomp_group_seq:"",
    s_mcomp_sort_detail:"",
    order_id: "a_product_name",
    group_id:"a_product_par_id, a_product_par_seq",
    // s_addon_order:"1",
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0,"group_tot":0 });

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    tmp_list_opt["s_order_state"]=tmp_list_opt["s_state"];
    tmp_list_opt["s_order_date_type"]="a_date";
    tmp_list_opt["s_order_s_start_date"]=tmp_list_opt["s_start_date"];
    tmp_list_opt["s_order_s_end_date"]=tmp_list_opt["s_end_date"];
    tmp_list_opt["s_order_in_out"]=tmp_list_opt["s_in_out"];

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order_det/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
   if(params.key=="row_tot"||params.key=="a_amount"||params.key=="a_price_sum"){
      params.value=strFunc.comma(params.value);
   }else if(params.key=="row_view_row_num"){
      params.value=params.idx+1+(listOptRef.current.now_page-1)*listOptRef.current.num_per_page;
   }

    return params.value;
  };

  return (
    <div>
      <div>
        <TopTabArea
          listOpt={listOpt}
          setListOpt={setListOpt}
          list={list}
        ></TopTabArea>
      </div>
      <div className='mt-2'>
        <SearchArea
          listOpt={listOpt}
          setListOpt={setListOpt}
          list={list}
          is_show_order_det_search={true}
        ></SearchArea>
      </div>
      <div className='mt-1'>
        <SumMoneyArea
          countInfo={countInfo}
          is_show_pay_money={false}
        ></SumMoneyArea>
      </div>
      <div className="mt-1">
        <ListComponent
          ref={ListComponentRef}
          xColumnArr={{ ...xColumnArr }}
          gridOpt={{
            fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
            is_add_idx_num: false,
            is_add_checkbox: true,
            td_align: "center",
            height: "auto",
            is_fix_width: true,
            rowMultiSelectWithClick: false,
            onGridReady: () => {

            },

            is_all_select_row_key: true,
            rowOnClick: rowOnClick,
            customCellRenderer: customCellRenderer,
            class_name_json: {
              table_div: "basic_list_div",
              td_div: "row-col-div",
              input_check: "chk_row",
              row_input: "row-input",
              data_row_tr: "data_row_tr",
              active_row: "active",
              empty_con_div: "list_empty_content_div",
            },
          }}
        ></ListComponent>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.group_tot}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        is_view_num_per_page={true}
        is_show_total_rec={true}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
    </div>
  );
}

export default ListBookGroupArea;